import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  Select,
  MenuItem,
  Button,
  Snackbar,
  Alert
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import apiUrl from '../config'; // Assure-toi que ton apiUrl est bien importé
import '../CSS/ajouterdeclarations.css';
import LayoutDashboard from "../layout/LayoutDashboard";

const AjouterMaladie = () => {
    const [selectedMonth, setSelectedMonth] = useState('');
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [maladieDays, setMaladieDays] = useState({});
    const [blockedDaysMap, setBlockedDaysMap] = useState({});
    const [isDragging, setIsDragging] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [declarationId, setDeclarationId] = useState(null);
    const [notification, setNotification] = useState({ open: false, message: '', severity: 'success' });
    const [loading, setLoading] = useState(false);
    const [loadingEditView, setLoadingEditView] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const [isDaysLoading, setIsDaysLoading] = useState(false);
    const [pdfFile, setPdfFile] = useState(null);
    const [initialMaladieDays, setInitialMaladieDays] = useState({});
    const [initialLoaded, setInitialLoaded] = useState(false);
    const [monthMaladieBlocked, setMonthMaladieBlocked] = useState(false);
    const [monthMaladieBlockedMessage, setMonthMaladieBlockedMessage] = useState('');

    // V166_FORCE_REAL_RENDERED_DAY_COLORS_MALADIE
    useEffect(() => {
        const toKey = (date) => {
            const y = date.getFullYear();
            const m = String(date.getMonth() + 1).padStart(2, '0');
            const d = String(date.getDate()).padStart(2, '0');
            return `${y}-${m}-${d}`;
        };

        const addDays = (date, days) => {
            const clone = new Date(date);
            clone.setDate(clone.getDate() + days);
            return clone;
        };

        const getEasterDate = (year) => {
            const a = year % 19;
            const b = Math.floor(year / 100);
            const c = year % 100;
            const d = Math.floor(b / 4);
            const e = b % 4;
            const f = Math.floor((b + 8) / 25);
            const g = Math.floor((b - f + 1) / 3);
            const h = (19 * a + b - d - g + 15) % 30;
            const i = Math.floor(c / 4);
            const k = c % 4;
            const l = (32 + 2 * e + 2 * i - h - k) % 7;
            const mm = Math.floor((a + 11 * h + 22 * l) / 451);
            const month = Math.floor((h + l - 7 * mm + 114) / 31);
            const day = ((h + l - 7 * mm + 114) % 31) + 1;
            return new Date(year, month - 1, day);
        };

        const getFrenchHolidayKeys = (year) => {
            const easter = getEasterDate(year);

            return new Set([
                new Date(year, 0, 1),
                addDays(easter, 1),
                new Date(year, 4, 1),
                new Date(year, 4, 8),
                addDays(easter, 39),
                addDays(easter, 50),
                new Date(year, 6, 14),
                new Date(year, 7, 15),
                new Date(year, 10, 1),
                new Date(year, 10, 11),
                new Date(year, 11, 25),
            ].map(toKey));
        };

        const clearForced = (cell, isHeader = false) => {
            if (!cell || cell.dataset.novaForcedRealColor !== 'true') return;

            [
                'background',
                'background-color',
                'background-image',
                'border',
                'color',
                'box-shadow',
                'opacity'
            ].forEach((prop) => cell.style.removeProperty(prop));

            cell.style.setProperty('cursor', isHeader ? 'default' : 'pointer');

            delete cell.dataset.novaForcedRealColor;
            delete cell.dataset.novaForcedRealType;
        };

        const forceCell = (cell, type) => {
            if (!cell) return;

            const palette = {
                weekend: {
                    background: 'linear-gradient(135deg, #cbd5e1, #e2e8f0)',
                    border: '2px dashed #94a3b8'
                },
                holiday: {
                    background: 'linear-gradient(135deg, #94a3b8, #64748b)',
                    border: '2px dashed #64748b'
                },
                existing: {
                    background: 'linear-gradient(135deg, #93c5fd, #60a5fa)',
                    border: '2px dashed #3b82f6'
                }
            };

            const color = palette[type];
            if (!color) return;

            cell.dataset.novaForcedRealColor = 'true';
            cell.dataset.novaForcedRealType = type;

            cell.style.setProperty('background', color.background, 'important');
            cell.style.setProperty('background-color', type === 'existing' ? '#93c5fd' : type === 'holiday' ? '#94a3b8' : '#cbd5e1', 'important');
            cell.style.setProperty('background-image', color.background, 'important');
            cell.style.setProperty('border', color.border, 'important');
            cell.style.setProperty('color', '#0f172a', 'important');
            cell.style.setProperty('cursor', 'not-allowed', 'important');
            cell.style.setProperty('opacity', '1', 'important');
            cell.style.setProperty('box-shadow', 'inset 0 1px 0 rgba(255,255,255,0.20)', 'important');
        };

        const applyColors = () => {
            const table = document.querySelector('.declarations-add-page table');
            if (!table || !selectedMonth || !selectedYear) return;

            const rows = Array.from(table.querySelectorAll('tr'));
            if (!rows.length) return;

            const headerRow = rows[0];
            const headerCells = Array.from(headerRow.querySelectorAll('th, td')).slice(1);
            const bodyRows = rows.slice(1);
            const holidays = getFrenchHolidayKeys(Number(selectedYear));

            headerCells.forEach((headerCell, index) => {
                const day = index + 1;
                const date = new Date(Number(selectedYear), Number(selectedMonth) - 1, day);

                if (date.getMonth() !== Number(selectedMonth) - 1) return;

                const dateKey = toKey(date);
                const isWeekendDay = date.getDay() === 0 || date.getDay() === 6;
                const isHolidayDay = holidays.has(dateKey);

                if (isHolidayDay) {
                    forceCell(headerCell, 'holiday');
                } else if (isWeekendDay) {
                    forceCell(headerCell, 'weekend');
                } else {
                    clearForced(headerCell, true);
                }

                bodyRows.forEach((row) => {
                    const cells = Array.from(row.querySelectorAll('th, td'));
                    const cell = cells[index + 1];

                    if (!cell) return;

                    const isExisting = blockedDaysMap?.[day] === 'bloqué';

                    if (isExisting) {
                        forceCell(cell, 'existing');
                    } else if (isHolidayDay) {
                        forceCell(cell, 'holiday');
                    } else if (isWeekendDay) {
                        forceCell(cell, 'weekend');
                    } else {
                        clearForced(cell, false);
                    }
                });
            });
        };

        applyColors();

        const timers = [
            setTimeout(applyColors, 50),
            setTimeout(applyColors, 200),
            setTimeout(applyColors, 600),
            setTimeout(applyColors, 1200)
        ];

        return () => {
            timers.forEach(clearTimeout);
        };
    }, [selectedMonth, selectedYear, blockedDaysMap, maladieDays]);


    const normalizeUserId = (raw) => {
        if (!raw) return null;
        if (typeof raw === 'object') return raw.id || raw.Id_Utilisateur || null;
        return raw;
    };

    const splitNovaDates = (value) => {
        return String(value || '')
            .split('/')
            .map((item) => item.trim())
            .filter(Boolean);
    };

    const dateBelongsToMonth = (dateValue, month, year) => {
        const match = String(dateValue || '').match(/(\d{4})-(\d{1,2})-(\d{1,2})/);

        if (!match) return false;

        return Number(match[1]) === Number(year) && Number(match[2]) === Number(month);
    };

    const declarationHasMaladieForMonth = (declaration, month, year) => {
        const maladieDates = splitNovaDates(
            declaration.jours_maladie ||
            declaration.Jours_Maladie ||
            declaration.joursMaladie
        );

        return maladieDates.some((date) => dateBelongsToMonth(date, month, year));
    };

    const checkMaladieMonthAlreadyExists = async (month, year, userId) => {
        const validUserId = normalizeUserId(userId);

        const pageIsEditMode = Boolean(isEditMode || declarationId || location.state?.declarationId);

        if (!validUserId || !month || !year || pageIsEditMode) {
            setMonthMaladieBlocked(false);
            setMonthMaladieBlockedMessage('');
            return false;
        }

        try {
            const token = localStorage.getItem('token');

            const response = await axios.get(`${apiUrl}/declarations/${validUserId}`, {
                headers: { Authorization: `Bearer ${token}` }
            });

            const declarations = Array.isArray(response.data)
                ? response.data
                : Array.isArray(response.data?.declarations)
                    ? response.data.declarations
                    : Array.isArray(response.data?.data)
                        ? response.data.data
                        : [];

            const exists = declarations.some((declaration) =>
                declarationHasMaladieForMonth(declaration, month, year)
            );

            if (exists) {
                const message = 'Un arrêt maladie existe déjà pour ce mois. Pour corriger les jours, passez par Modifier.';

                setMonthMaladieBlocked(true);
                setMonthMaladieBlockedMessage(message);
                setNotification({
                    open: true,
                    message,
                    severity: 'warning'
                });

                return true;
            }

            setMonthMaladieBlocked(false);
            setMonthMaladieBlockedMessage('');
            return false;
        } catch (error) {
            console.error('Erreur vérification arrêt maladie existant :', error);
            setMonthMaladieBlocked(false);
            setMonthMaladieBlockedMessage('');
            return false;
        }
    };


    


    // V152_CLEAR_MALADIE_BLOCK_ON_EDIT
    useEffect(() => {
        const pageIsEditMode = Boolean(isEditMode || declarationId || location.state?.declarationId);

        if (pageIsEditMode) {
            setMonthMaladieBlocked(false);
            setMonthMaladieBlockedMessage('');
        }
    }, [isEditMode, declarationId, location.state]);

    useEffect(() => {
  const loadDetails = async () => {
    const token = localStorage.getItem("token");
    const tokenData = JSON.parse(atob(token.split(".")[1]));
    const userIdFromToken = tokenData.user_id;

    let userId = location.state?.selectedUserId || userIdFromToken;
    setSelectedUserId(userId);

    // 👉 Si on modifie une déclaration
    if (location.state?.declarationId) {
      setIsEditMode(true);
      setDeclarationId(location.state.declarationId);

      setIsDaysLoading(true); // ✅ Affiche immédiatement le message

      try {
        const response = await axios.get(`${apiUrl}/maladies/${location.state.declarationId}`, {
          headers: { Authorization: `Bearer ${token}` }
        });

        if (response.status === 200) {
          const declaration = response.data;
          const maladieArray = declaration.jours_maladie && declaration.jours_maladie !== "0"
            ? declaration.jours_maladie
              .split("/  ")
              .map(date => date.trim())
              .filter(Boolean)
            : [];

          const maladieObj = {};
          maladieArray.forEach(dateStr => {
  const d = new Date(dateStr);
  const day = d.getDate();
  maladieObj[day] = 1;
});

          setInitialMaladieDays(maladieObj);
          setMaladieDays(maladieObj);
          setInitialLoaded(true);

          let extractedMonth = location.state?.selectedMonth;
          let extractedYear = location.state?.selectedYear;

          if (!extractedMonth && maladieArray.length > 0) {
            const firstDate = new Date(maladieArray[0]);
            extractedMonth = firstDate.getMonth() + 1;
            extractedYear = firstDate.getFullYear();
          }

          if (extractedMonth && extractedYear) {
            setSelectedMonth(extractedMonth);
            setSelectedYear(extractedYear);
            await handleMonthChange(extractedMonth, userId, maladieObj); // ✅ c’est ici que setIsDaysLoading(false) sera appelé
          }
        }
      } catch (error) {
        console.error('Erreur lors du chargement des données de maladie:', error);
        setIsDaysLoading(false); // fail-safe
      }
    }
  };

  loadDetails();
}, [location.state]);

//////////////////////

useEffect(() => {
    const chargerJoursMaladie = async () => {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${apiUrl}/declarations/${selectedUserId}`, {
        headers: { Authorization: `Bearer ${token}` }
    });

    const joursMaladieTrouvés = {};

    if (response.status === 200) {
        const toutesDeclarations = response.data;

        toutesDeclarations.forEach((decl) => {
            const joursMaladie = decl.jours_maladie;
            if (joursMaladie && joursMaladie !== "0") {
                joursMaladie.split('/').forEach(dateStr => {
                    const date = new Date(dateStr.trim());
                    if (
                        date.getFullYear() === selectedYear &&
                        date.getMonth() + 1 === selectedMonth
                    ) {
                        joursMaladieTrouvés[date.toLocaleDateString('fr-CA')] = 1;
                    }
                });
            }
        });
    }

    return joursMaladieTrouvés;
};

    if (!isEditMode && selectedMonth && selectedYear && selectedUserId) {
        setIsDaysLoading(true); 
        chargerJoursMaladie().then((jours) => {
    setInitialMaladieDays(jours);
    handleMonthChange(selectedMonth, selectedUserId, jours);
});
    }
}, [selectedMonth, selectedYear, selectedUserId, isEditMode]);

const [monthHandled, setMonthHandled] = useState(false);

  const handleMonthChange = async (input, userIdOverride = null, joursMaladie = null) => {
    const month = typeof input === 'number' ? input : parseInt(input.target.value);

     if (!isEditMode) {
        setSelectedMonth(month);
    }
    
    setIsDaysLoading(true);

    const userIdRaw = userIdOverride || selectedUserId;
    const validUserId = typeof userIdRaw === 'object'
        ? userIdRaw?.id || userIdRaw?.Id_Utilisateur
        : userIdRaw;

    if (!validUserId || !selectedYear || !month) {
        console.warn("handleMonthChange bloqué : ID, année ou mois manquant");
        setIsDaysLoading(false);
        return;
    }

    await checkMaladieMonthAlreadyExists(month, selectedYear, validUserId);

    try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${apiUrl}/maladies/jours-bloques/${validUserId}/${month}/${selectedYear}`, {
            headers: { Authorization: `Bearer ${token}` }
        });

        const jours = {};

        // 🟢 Utilise les jours maladie donnés en paramètre (si fournis)
        const maladieSource = joursMaladie || maladieDays;

        for (const [day, value] of Object.entries(maladieSource)) {
    jours[parseInt(day)] = value;
}

        if (response.status === 200) {
    const joursBloques = response.data;

    for (const jour of joursBloques) {

        // NE PAS bloquer les jours maladie existants
        if (jours[jour] !== 1) {
            jours[jour] = "bloqué";
        }

    }
}
// restaurer les jours maladie sélectionnés
for (const [day, value] of Object.entries(maladieSource)) {
    jours[parseInt(day)] = 1;
}

        const daysInMonth = new Date(selectedYear, month, 0).getDate();
        for (let day = 1; day <= daysInMonth; day++) {
            const date = new Date(selectedYear, month - 1, day);
            const dateStr = date.toLocaleDateString('fr-CA');
            const isWeekend = date.getDay() === 0 || date.getDay() === 6;
            if ((isWeekend || holidays.has(dateStr)) && !(day in jours)) {
                jours[day] = "bloqué";
            }
        }

        setBlockedDaysMap(jours);
       
    } catch (error) {
        console.error("❌ Erreur lors du chargement des jours bloqués :", error);
    } finally {
        setIsDaysLoading(false);
    }
};
         
    const handleYearChange = (e) => {
        const year = parseInt(e.target.value);
        setSelectedYear(year);
        
    };

    const getDaysInMonth = (year, month) => {
        const daysInMonth = new Date(year, month, 0).getDate();
        return Array.from({ length: daysInMonth }, (_, i) => i + 1);
    };

    const toggleDay = (day) => {

if (monthMaladieBlocked) {
    setNotification({
        open: true,
        message: monthMaladieBlockedMessage || 'Un arrêt maladie existe déjà pour ce mois. Pour corriger les jours, passez par Modifier.',
        severity: 'warning'
    });
    return;
}

if (blockedDaysMap[day] === "bloqué") return;

if (maladieDays[day] === 1) {
    const newMaladieDays = { ...maladieDays };
    delete newMaladieDays[day];
    setMaladieDays(newMaladieDays);
} else {
    setMaladieDays({ ...maladieDays, [day]: 1 });
}

};  

    const handleMouseDown = (day) => {
        setIsDragging(true);
        toggleDay(day);
    };

    const handleMouseOver = (day) => {
        if (isDragging) {
            toggleDay(day);
        }
    };

    const handleMouseUp = () => {
        setIsDragging(false);
    };

    const handleSubmit = async () => {
        try {
            setLoading(true);

            const alreadyMaladie = await checkMaladieMonthAlreadyExists(selectedMonth, selectedYear, selectedUserId);
            if (alreadyMaladie) {
                setLoading(false);
                return;
            }
            const token = localStorage.getItem('token');
    
            if (!pdfFile) {
                setNotification({ open: true, message: "Veuillez sélectionner un fichier PDF.", severity: 'error' });
                setLoading(false);
                return;
            }
    
            const formattedMaladieDays = Object.keys(maladieDays)
                .filter(day => maladieDays[day] === 1)
                .map(day => new Date(selectedYear, selectedMonth - 1, day).toLocaleDateString('fr-CA'));
    
            const formData = new FormData();
            formData.append('document', pdfFile); // ✅ le fichier PDF
            formData.append('data', JSON.stringify({
    maladieDays: formattedMaladieDays,
    Id_Utilisateur: selectedUserId,
    Id_Declaration: declarationId
}));
    
            const response = await axios.post(`${apiUrl}/maladies`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data'
                }
            });
    
            if (response.status === 200 || response.status === 201) {
                setNotification({
                    open: true,
                    message: 'Arrêt maladie ajouté avec succès.',
                    severity: 'success'
                });
            
                if (response.status === 201) {
                    setNotification({
                        open: true,
                        message: 'Arrêt maladie ajouté avec succès.',
                        severity: 'success'
                    });
                }
            }            
    
        } catch (error) {
            console.error("Erreur lors de l'ajout :", error);
            setNotification({ open: true, message: "Erreur lors de l’ajout de l’arrêt maladie.", severity: 'error' });
        } finally {
            setLoading(false);
        }
    };    
    
   const handleUpdate = async () => {
    try {
        setLoading(true);
        const token = localStorage.getItem('token');

        const formattedMaladieDays = Object.keys(maladieDays)
            .filter(day => maladieDays[day] === 1)
            .map(day => new Date(selectedYear, selectedMonth - 1, day).toLocaleDateString('fr-CA'));

        const formData = new FormData();

        if (pdfFile) {
            formData.append('document', pdfFile);
        }

        formData.append('data', JSON.stringify({
    maladieDays: formattedMaladieDays,
    Id_Utilisateur: selectedUserId,
    Id_Declaration: declarationId
}));

        const response = await axios.put(`${apiUrl}/maladies/${declarationId}`, formData, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'multipart/form-data'
            }
        });

        if (response.status === 200) {
            setNotification({
                open: true,
                message: 'Arrêt maladie modifié avec succès.',
                severity: 'success'
            });
        }
    } catch (error) {
        console.error("Erreur lors de la mise à jour de l'arrêt maladie :", error);

        let errorMessage = "Erreur lors de la mise à jour.";
        if (error.response && error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message;
        }

        setNotification({
            open: true,
            message: errorMessage,
            severity: 'error'
        });

        // ❌ On ne redirige pas en cas d’erreur
        return;
    } finally {
        setLoading(false);
    }
};
 

    const getFrenchHolidays = (year) => {
        const holidays = new Set([
            `${year}-01-01`, `${year}-05-01`, `${year}-05-08`, `${year}-07-14`, `${year}-08-15`,
            `${year}-11-01`, `${year}-11-11`, `${year}-12-25`
        ]);
        const a = year % 19, b = Math.floor(year / 100), c = year % 100;
        const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
        const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
        const i = Math.floor(c / 4), k = c % 4;
        const l = (32 + 2 * e + 2 * i - h - k) % 7;
        const m = Math.floor((a + 11 * h + 22 * l) / 451);
        const month = Math.floor((h + l - 7 * m + 114) / 31);
        const day = ((h + l - 7 * m + 114) % 31) + 1;
        const easter = new Date(year, month - 1, day);
        const easterMonday = new Date(easter); easterMonday.setDate(easter.getDate() + 1);
        const ascensionDay = new Date(easter); ascensionDay.setDate(easter.getDate() + 39);
        const pentecostMonday = new Date(easter); pentecostMonday.setDate(easter.getDate() + 50);
        holidays.add(easter.toLocaleDateString('fr-CA'));
        holidays.add(easterMonday.toLocaleDateString('fr-CA'));
        holidays.add(ascensionDay.toLocaleDateString('fr-CA'));
        holidays.add(pentecostMonday.toLocaleDateString('fr-CA'));
        return holidays;
    };

    const holidays = getFrenchHolidays(selectedYear);

    const isHoliday = (day, month, year, holidays) => {
        if (!month || !year) return false;
        const date = new Date(year, month - 1, day);
        return holidays.has(date.toLocaleDateString('fr-CA'));
    };

    const isWeekend = (day, month, year) => {
        const date = new Date(year, month - 1, day);
        return date.getDay() === 0 || date.getDay() === 6;
    };

    const isToday = (day, month, year) => {
        const today = new Date();
        return day === today.getDate() && month === today.getMonth() + 1 && year === today.getFullYear();
    };

    const daysInMonth = selectedMonth ? getDaysInMonth(selectedYear, selectedMonth) : [];

    return (
        <LayoutDashboard>
        <div className="declarations-add-page" onMouseUp={handleMouseUp}>
    <Container maxWidth="lg" sx={{ p: 0 }}>
                    <div className="header">
                        <Typography variant="h1">
                            {isEditMode ? "Modifier un arrêt maladie" : "Ajouter un arrêt maladie"}
                        </Typography>
                    </div>

                    <div className="month-selector">

<Typography variant="h6" sx={{ color: '#0B349D' }}>
Sélectionner le Mois et l'Année :
</Typography>

<div className="select-row">
                        <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
                            <Select value={selectedMonth || ''} onChange={handleMonthChange} displayEmpty variant="outlined" fullWidth sx={{ bgcolor: 'white', borderRadius: '4px' }}>
                                <MenuItem value="" disabled>Choisir un mois</MenuItem>
                                {Array.from({ length: 12 }, (_, index) => (
                                    <MenuItem key={index + 1} value={index + 1}>{new Date(0, index).toLocaleString('default', { month: 'long' })}</MenuItem>
                                ))}
                            </Select>
                            <Select value={selectedYear} onChange={handleYearChange} displayEmpty variant="outlined" fullWidth sx={{ bgcolor: 'white', borderRadius: '4px' }}>
                                {Array.from({ length: 5 }, (_, index) => {
                                    const year = 2025 + index;
                                    return <MenuItem key={year} value={year}>{year}</MenuItem>;
                                })}
                            </Select>
                        </div>
                        </div>
                    </div>

                    {selectedMonth && !isDaysLoading && (
                        <div className="table-wrapper" style={{ overflowX: 'auto', whiteSpace: 'nowrap', display: 'block', maxWidth: '100%' }}>
                            <table className="styled-table" style={{ tableLayout: 'fixed', width: '150%' }}>
                                <thead>
                                    <tr>
                                        <th className="main-column">Jours du Mois</th>
                                        {daysInMonth.map(day => {
                                            const isCurrent = isToday(day, selectedMonth, selectedYear);
                                            const isWeekendDay = isWeekend(day, selectedMonth, selectedYear);
                                            const isHolidayDay = isHoliday(day, selectedMonth, selectedYear, holidays);

                                            return (
                                                <th
                                                    key={day}
                                                    className={`day-column ${isWeekendDay ? 'nova-weekend-day-cell' : ''} ${isHolidayDay ? 'nova-holiday-day-cell' : ''}`.trim()}
                                                    style={{
                                                        minWidth: '80px',
                                                        backgroundColor: isCurrent
                                                            ? '#fff2b3'
                                                            : isHolidayDay
                                                            ? '#94a3b8'
                                                            : isWeekendDay
                                                            ? '#cbd5e1'
                                                            : '',
                                                        color: isCurrent ? 'black' : (isWeekendDay || isHolidayDay) ? '#0f172a' : '',
                                                        fontWeight: isCurrent ? 'bold' : 'normal',
                                                        border: isHolidayDay ? '2px dashed #64748b' : isWeekendDay ? '2px dashed #94a3b8' : undefined,
                                                        cursor: isWeekendDay || isHolidayDay ? 'not-allowed' : 'default'
                                                    }}
                                                >
                                                    {day}
                                                </th>
                                            );
                                        })}
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="main-column">Jours de Maladie</td>
                                        {daysInMonth.map(day => {
                                            const isWeekendDay = isWeekend(day, selectedMonth, selectedYear);
                                            const isHolidayDay = isHoliday(day, selectedMonth, selectedYear, holidays);
                                            const isGray = isWeekendDay || isHolidayDay;
                                           const isBlocked = blockedDaysMap[day] === "bloqué"; // jour déjà déclaré comme travail/congé
                                            const isSelected = maladieDays[day] === 1 || maladieDays[day] === '1';
                                            return (
                                                <td
                                                    className={`${isWeekendDay ? 'nova-weekend-day-cell' : ''} ${isHolidayDay ? 'nova-holiday-day-cell' : ''} ${isBlocked ? 'nova-existing-day-cell' : ''}`.trim()}
                                                    key={`maladie-${day}`}
                                                    onMouseDown={() => !isGray && !isBlocked && handleMouseDown(day)}
                                                    onMouseOver={() => !isGray && !isBlocked && handleMouseOver(day)}
                                                    onMouseUp={handleMouseUp}
                                                    style={{
                                                        backgroundColor: isBlocked
                                                            ? '#93c5fd'
                                                            : isHolidayDay
                                                            ? '#94a3b8'
                                                            : isWeekendDay
                                                            ? '#cbd5e1'
                                                            : isSelected
                                                            ? '#f28c8c'
                                                            : '',
                                                        cursor: isGray || isBlocked ? 'not-allowed' : 'pointer',
                                                        minWidth: '80px',
                                                        color: (isGray || isBlocked) ? '#0f172a' : undefined,
                                                        border: isBlocked
                                                            ? '2px dashed #3b82f6'
                                                            : isHolidayDay
                                                            ? '2px dashed #64748b'
                                                            : isWeekendDay
                                                            ? '2px dashed #94a3b8'
                                                            : undefined
                                                    }}
                                                >
                                                    {maladieDays[day] === 1 ? '1' : ''}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    )}

<Typography variant="h6" sx={{ color: '#0B349D', marginTop: '20px' }}>Fichier d'arrêt maladie (PDF obligatoire) :</Typography>
<input
    type="file"
    accept="application/pdf"
    onChange={(e) => setPdfFile(e.target.files[0])}
/>

                    <div className="actions-row">
                        <Button
className="primary-btn"
onClick={isEditMode ? () => handleUpdate(location.state.declarationId) : handleSubmit}
                            disabled={!isEditMode && monthMaladieBlocked}
>
                            {isEditMode ? "Valider les modifications" : "Ajouter l'arrêt maladie"}
                        </Button>
                        <Button variant="contained" style={{ backgroundColor: '#1f6391', color: 'white' }}
                            onClick={() => navigate('/Déclarations', { state: { selectedUserId } })} >
                            Retourner aux CRA
                        </Button>
                    </div>

{!isEditMode && !declarationId && !location.state?.declarationId && monthMaladieBlocked && (
                        <Alert
                            className="nova-month-block-alert"
                            severity="warning"
                            sx={{
                                mb: 2,
                                borderRadius: '14px',
                                fontWeight: 800,
                                boxShadow: '0 10px 24px rgba(245, 158, 11, 0.16)'
                            }}
                        >
                            {monthMaladieBlockedMessage}
                        </Alert>
                    )}

{isDaysLoading && (
  <div style={{ textAlign: 'center', marginTop: '20px' }}>
    
    <Typography variant="body1">Chargement des jours, merci de patienter...</Typography>
  </div>
)}
                    {loading && (
                        <Snackbar open={true} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} autoHideDuration={null}>
                            <Alert severity="info" sx={{ width: '100%', fontSize: '1rem', fontWeight: 'bold', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                
                                Merci de patienter...
                            </Alert>
                        </Snackbar>
                    )}

<Snackbar
    key={notification.message}
    open={notification.open}
    autoHideDuration={2000} // ⬅️ suffisant pour que onClose soit bien appelé
    onClose={() => {
    setNotification({ ...notification, open: false });
    if (notification.severity === 'success') {
        navigate('/Déclarations', { state: { userId: selectedUserId } });
    }
}}
    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
    <Alert severity={notification.severity} sx={{ width: '100%', fontSize: '1rem', fontWeight: 'bold', display: 'flex', justifyContent: 'center', alignItems: 'center', boxShadow: '0 4px 8px rgba(0,0,0,0.2)', borderRadius: '8px' }}>
        {notification.message}
    </Alert>
</Snackbar>
                </Container>
            </div>
        
        </LayoutDashboard>
    );
};

export default AjouterMaladie;
